export default {
    MessageMark: 'Mark',
    MessageUnmark: 'Unmark',
    MessageInvisibilitk: 'Invisibilitk',
    MessageVisible: 'Visible',
    MessageAddBlacklist: 'Add Blacklist',
    MessageRemoveTheBlacklist: 'Remove the blacklist',
    MessageClearChatRecord: 'Clear chat record',
    MessageDeleteContact: 'Delete Contact',
}